<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'badge-dollar']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('navigation.content_customer_title') }}
        </span>
      </div>
    </template>

    <template #cta>
      <BaseButton
        v-if="$can('manage_content')"
        color="primary"
        icon="plus"
        @click="this.$router.push({ name: 'settings_create_customer_route' })"
        :title="$t('button.add_new_m', { var: $t('global.customer') })"
      />
    </template>

    <template #body>
      <BaseContentTable
        v-if="metadata.columns || loading"
        :columns="metadata.columns ?? []"
        :loading="loading"
        :modelList="customerList"
        :search="true"
        @rowClick="redirectToModelPage"
        @refreshClick="withLoading(fetchAllCustomer())"
        @deleteModel="deleteCustomer"
        :isHoverable="true"
      />
    </template>
  </SettingsPageFull>
</template>

<script>
import loadingMixin from '@u/mixins/loading.mixin'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TheCustomerIndexPage',
  mixins: [loadingMixin],
  computed: {
    ...mapGetters({
      customerList: 'customer/getCustomerList',
      metadata: 'customer/getCustomerMetadata'
    })
  },
  methods: {
    ...mapActions({
      fetchAllCustomer: 'customer/fetchAllCustomer',
      deleteCustomerById: 'customer/deleteCustomerById',
      undoDeleteCustomerById: 'customer/undoDeleteCustomerById'
    }),
    redirectToModelPage(id) {
      this.$router.push({
        name: 'settings_edit_customer_route',
        params: { id: id }
      })
    },
    deleteCustomer(id) {
      this.deleteCustomerById({
        id: id
      }).then(() => {
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_m', { var: this.$t('attributes.customer') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => this.undoDeleteCustomer(id)
            }
          ]
        )
      })
    },
    undoDeleteCustomer(id) {
      this.undoDeleteCustomerById({
        id: id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.reseted_m', { var: this.$t('attributes.customer') })
        )
      })
    }
  },
  mounted() {
    this.withLoading(this.fetchAllCustomer())
  }
}
</script>
